import { AUTH_CONST, TENANT_CONST } from '@/constant';
import { storage } from '@/package';

const { VITE_APP_API_URL } = import.meta.env;

class ExportException {
  static instance: ExportException;

  constructor() {
    if (ExportException.instance) return ExportException.instance;

    ExportException.instance = this;
  }

  report(data: any) {
    const idToken = storage.local.get<string>(AUTH_CONST.KEYS.STORAGE_ID_TOKEN);
    const tenantID = storage.local.get<string>(
      TENANT_CONST.KEYS.STORAGE_CURRENT_TENANT_ID,
    );

    if (!idToken || !tenantID) return;

    return fetch(`${VITE_APP_API_URL}/bug-report`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${idToken}`,
        'X-Tenant-ID': tenantID,
      },
      body: JSON.stringify(data),
    });
  }
}

export const exportException = new ExportException();
